import * as React from 'react';
import { FunctionComponent } from 'react';
import { Tournament } from '../../models/tournament';
import { getSpaces } from '../../helpers/tournament/tournament';

interface Props {
  tournament: Tournament;
  schoolsWaitingListCount: number;
}

type SummaryItem = {
  label: string;
  value: React.ReactNode;
};

export const TournamentAutoEnrollmentSummary: FunctionComponent<Props> = ({ tournament, schoolsWaitingListCount }) => {
  const items: SummaryItem[] = [
    {
      label: 'Autoenrollment',
      value: tournament.isAutoEnrollmentTeams ? 'Yes' : 'No'
    },
    {
      label: 'Spaces',
      value: getSpaces(tournament)
    },
    {
      label: 'Waiting list',
      value: String(schoolsWaitingListCount)
    },
    {
      label: 'Move tournament to waiting list mode once full',
      value: tournament.isEnableWaitingListWhenFull ? 'Yes' : 'No'
    },
    {
      label: 'Enrollment onto the waiting list only',
      value: tournament.isAutoEnrollmentToWaitingList ? 'Yes' : 'No'
    },
    {
      label: 'Schools in read-only mode',
      value: tournament.isReadOnly ? 'Yes' : 'No'
    }
  ];

  return (
    <div className="tournamentSummaryBody">
      <div className="tournamentAutoEnrollmentKpis">
        <div className="tournamentAutoEnrollmentKpi">
          <div className="tournamentAutoEnrollmentKpiLabel">Autoenrollment</div>
          <div className="tournamentAutoEnrollmentKpiValue">{tournament.isAutoEnrollmentTeams ? 'Yes' : 'No'}</div>
        </div>

        <div className="tournamentAutoEnrollmentKpi">
          <div className="tournamentAutoEnrollmentKpiLabel">Spaces</div>
          <div className="tournamentAutoEnrollmentKpiValue">{getSpaces(tournament)}</div>
        </div>

        <div className="tournamentAutoEnrollmentKpi">
          <div className="tournamentAutoEnrollmentKpiLabel">Waiting list</div>
          <div className="tournamentAutoEnrollmentKpiValue">{schoolsWaitingListCount}</div>
        </div>
      </div>

      <div className="tournamentSummaryItem">
        <div className="tournamentSummaryItemLabel">Rules</div>
        <div className="tournamentSummaryItemValue">
          <div className="tournamentSummaryInlineGroups">
            <span className="tournamentSummaryInlineGroup">
              <span className="tournamentSummaryInlineGroupLabel">Move to waiting list once full</span>
              <span className="tournamentSummaryInlineGroupValue">
                {tournament.isEnableWaitingListWhenFull ? 'Yes' : 'No'}
              </span>
            </span>

            <span className="tournamentSummaryInlineGroup">
              <span className="tournamentSummaryInlineGroupLabel">Waiting list only</span>
              <span className="tournamentSummaryInlineGroupValue">
                {tournament.isAutoEnrollmentToWaitingList ? 'Yes' : 'No'}
              </span>
            </span>

            <span className="tournamentSummaryInlineGroup">
              <span className="tournamentSummaryInlineGroupLabel">Schools read-only</span>
              <span className="tournamentSummaryInlineGroupValue">{tournament.isReadOnly ? 'Yes' : 'No'}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

TournamentAutoEnrollmentSummary.displayName = 'TournamentAutoEnrollmentSummary';
